import type { TokenAbility } from "../laravel.d.ts";

export const TokenAbilities: TokenAbility[] = ['create_tiny_url', 'update_tiny_url', 'change_long_url', 'delete_tiny_url', 'archive_tiny_url', 'use_analytics', 'download_logs', 'use_bulk', 'manage_expiration'];